import jwtDecode from 'jwt-decode';

import {
  AUTH_LOGOUT,
  AUTH_CHECK,
  AUTH_LOGIN,
  AUTH_SET_USER,
  AUTH_SET_LAST_ACTIVE_TIME,
  AUTH_SET_JUST_LOGGED_IN,
} from '../mutation-types';

export default {
  namespaced: true,
  state: {
    authenticated: false,
    userId: -1,
    roles: [],
    user: null,
    lastActiveTime: null,
    justLoggedIn: false,
    justRegistered: false,
    latitude: null,
    longitude: null,
  },
  mutations: {
    [AUTH_CHECK](state) {
      let data = localStorage.getItem('id_token');
      const hasToken = !!data;
      if (hasToken) {
        data = JSON.parse(data);
        const { token } = data;
        const { user } = data;
        const decoded = jwtDecode(token);
        // check expiration
        if (decoded.exp > Math.floor(new Date().getTime() / 1000)) {
          state.authenticated = true;
          state.roles = decoded.data.roles;
          state.userId = decoded.sub;
          state.user = user;
          state.justLoggedIn = true;
          const bearer = `Bearer ${token}`;
          window.axios.defaults.headers.common.Authorization = bearer;
        }
      }
    },
    [AUTH_LOGIN](state, data) {
      const { token } = data;
      const user = data.user.data;
      const bearer = `Bearer ${token}`;
      const decoded = jwtDecode(token);
      const objectToSave = { token, user };

      state.authenticated = true;
      state.roles = user.roles;
      state.userId = decoded.sub;
      state.user = user;
      state.justLoggedIn = true;
      localStorage.setItem('id_token', JSON.stringify(objectToSave));
      window.axios.defaults.headers.common.Authorization = bearer;
    },
    [AUTH_LOGOUT](state) {
      state.authenticated = false;
      state.roles = [];
      state.userId = -1;
      state.user = null;
      localStorage.removeItem('id_token');
      window.axios.defaults.headers.common.Authorization = '';
    },
    [AUTH_SET_USER](state, user) {
      state.user = user;

      let data = localStorage.getItem('id_token');
      const hasToken = !!data;
      if (hasToken) {
        data = JSON.parse(data);
        data.user = user;
        localStorage.setItem('id_token', JSON.stringify(data));
      }
    },
    [AUTH_SET_LAST_ACTIVE_TIME](state, time) {
      state.lastActiveTime = time;
    },
    [AUTH_SET_JUST_LOGGED_IN](state, value) {
      state.justLoggedIn = value;
    },
  },
  actions: {
    login({ commit }, data) {
      commit(AUTH_LOGIN, data);
    },
    logout({ commit }) {
      commit(AUTH_LOGOUT);
    },
    check({ commit }) {
      commit(AUTH_CHECK);
    },
    setUser({ commit }, user) {
      commit(AUTH_SET_USER, user);
    },
    setLastActiveTime({ commit }, time) {
      commit(AUTH_SET_LAST_ACTIVE_TIME, time);
    },
    setJustLoggedIn({ commit }, value) {
      commit(AUTH_SET_JUST_LOGGED_IN, value);
    },
  },
  getters: {},
};
